import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    EXPORT_ORDER,
    EXPORT_ORDER_DETAILS,
    GET_ORDER_DETAILS,
    GET_ORDER_LISTING,
    UPDATE_ORDER_STATUS,
} from "./actionTypes.js";

import {
    getOrderListingSuccess,
    getOrderListingFail,
    getOrderDetailsSuccess,
    getOrderDetailsFail,
    updateOrderStatusSuccess,
    updateOrderStatusFail,
    exportOrderSuccess,
    exportOrderFail,
    exportOrderDetailsSuccess,
    exportOrderDetailsFail,
} from "./actions.js";

import { exportOrderApi, exportOrderDetailsApi, orderListingApi } from "./orderApi.js";
import { orderDetailsApi } from "./orderApi.js";
import { orderUpdateStatusApi } from "./orderApi.js";

function* fetchOrderListing({ payload }) {
    try {
        const response = yield call(orderListingApi, payload);
        yield put(getOrderListingSuccess(response));
    } catch (error) {
        yield put(getOrderListingFail(error));
    }
}

function* fetchOrderDetails({ payload }) {
    try {
        const response = yield call(orderDetailsApi, payload);
        yield put(getOrderDetailsSuccess(response));
    } catch (error) {
        yield put(getOrderDetailsFail(error));
    }
}

function* updateOrderStatus({ payload }) {
    try {
        const response = yield call(orderUpdateStatusApi, payload);
        yield put(updateOrderStatusSuccess(response));
    } catch (error) {
        yield put(updateOrderStatusFail(error));
    }
}

function* exportOrder({ payload }) {
    try {
        const response = yield call(exportOrderApi, payload);
        yield put(exportOrderSuccess(response));
    } catch (error) {
        yield put(exportOrderFail(error));
    }
}

function* exportOrderDetails({ payload }) {
    try {
        const response = yield call(exportOrderDetailsApi, payload);
        yield put(exportOrderDetailsSuccess(response));
    } catch (error) {
        yield put(exportOrderDetailsFail(error));
    }
}

function* OrderSaga() {
    yield takeEvery(GET_ORDER_LISTING, fetchOrderListing);
    yield takeEvery(GET_ORDER_DETAILS, fetchOrderDetails);
    yield takeEvery(UPDATE_ORDER_STATUS, updateOrderStatus);
    yield takeEvery(EXPORT_ORDER, exportOrder);
    yield takeEvery(EXPORT_ORDER_DETAILS, exportOrderDetails);
}

export default OrderSaga